import { Translatable } from '@icc/shared/helpers';

/** Typ montażu */
export class MontageType {
    id: number;
    @Translatable({ model: 'MontageTypes' })
    name: string;
    description: string;
    shortDescription: string;
    /** Zawsze dostępny */
    alwaysAccessible: boolean;
    /** Zdjęcie 1 */
    photo1: string;
    /** Zdjęcie 2 */
    photo2: string;
    /** Grafiki per system – nadpisują globalne photo1/photo2 dla danego systemu (shutter_type_id) */
    shutterTypePhotos: { [shutterTypeId: number]: { photo1: string; photo2: string } };
    /** Przypisane typy produktów */
    shutterTypesIds: number[];
    /** Dostępny bez skrzynek/blach */
    availableWithoutCovers: boolean;
    /** Przypisane typy zestawów blach osłonowych */
    blindSheetSetTypesIds: number[];
    /** Przypisane typy blach osłonowych */
    blindSheetTypesIds: number[];
    /** Przypisane typy skrzynek */
    blindBoxTypesIds: number[];
    /** Sytuacje budowlane */
    situations: string;
    /** Opis w szczegółach pozycji "Sytuacja budowlana" */
    @Translatable({ model: 'MontageTypes' })
    situationsDescription: string;
    /** Wysokość żaluzji jest wysokością okna */
    heightEqualToWindow: boolean;
    /** Szerokość żaluzji jest równa szerokości okna */
    widthEqualToWindow: boolean;
    /** Sposób zabudowy */
    methodOfInstallation: 'internal' | 'external' | 'none' | 'internalAndExternal';
}
